import { GetTaskConfigurationSendDocumentTemplatesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useTaskConfigurationSendDocumentTemplate = (documentTemplateIds?: string[] | null) => {
  const variables = { documentTemplateIds: documentTemplateIds }

  const { data, loading } = useQuery(GetTaskConfigurationSendDocumentTemplatesDocument, {
    variables,
  })

  return {
    loading,
    taskConfigurations:
      data?.processes.taskConfigurationSendDocumentTemplatesConnection.nodes ?? [],
  }
}
